import { render } from "./TopMenu.vue?vue&type=template&id=2f2baf69&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=ts"
export * from "./TopMenu.vue?vue&type=script&lang=ts"

import "./TopMenu.vue?vue&type=style&index=0&id=2f2baf69&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f2baf69"

export default script